/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';

import Box from 'components/ui/box';
import { AuthContext, useAuth } from 'context/AuthContext';
// import { useModal } from 'context/ModalContext';
import { useState, useEffect, useRef, useContext, useMemo } from 'react';
import {
  getResultadosGaleriaReconhecimento,
  getResultadosGaleriaReconhecimentoSecond,
  getResultadosSelosBB,
} from 'services/dashboard.service';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Avatar from 'funifier-nice-avatar';
import { TbSearch } from 'react-icons/tb';
import { getChallengeUser } from 'services/challenges.service';
import CustomSelect from 'components/custom-select';
import { getIndexByValue } from 'utils/helpers';
import { BsCheck } from 'react-icons/bs';
import TabTitle from 'components/tab-title';
// import { GaleriaDetalheModal } from 'components/galeria-detalhe-modal';

const menu = ['Ciclo 2023/1', 'Ciclo 2022/2'];

export default function ChallengesLancamento() {
  const params = useParams();
  const navigate = useNavigate();

  const [list, setList] = useState<unknown[]>();
  const [optionsCycle, setOptionsCycle] = useState<any>([]);

  const [loadingList, setLoadingList] = useState(true);

  const { userInfo } = useAuth();
  const { realCycle } = useContext(AuthContext);

  const [total, setTotal] = useState<number>();
  const [totalCompleted, setTotalCompleted] = useState<number>();

  useEffect(() => {
    async function loadData() {
      if (userInfo?.chave) {
        setLoadingList(true);
        const data = await getChallengeUser();
        const _data = data.filter((item: any) => {
          if (item?.extra?.perfil === 'rede') return true;

          return false;
        });

        setTotalCompleted(_data.filter((item: any) => item.completed).length);
        setTotal(_data.length);
        setList(_data);
        setLoadingList(false);
      }
    }

    loadData();
  }, [userInfo]);

  useEffect(() => {
    if (!realCycle) return;

    const cycleOptions = realCycle
      .filter((item: any) => item?.date_start >= 1690772400000)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;

        return cycle;
      });

    setOptionsCycle(cycleOptions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realCycle]);

  function calculatePercentage(percentage: number | null, totalValue: number): number {
    if (!percentage) {
      return 0;
    }
    const calculatedValue = (totalValue / 100) * percentage;
    return Math.floor(calculatedValue);
  }

  function verifyRules(item: any): number {
    if (!item?.progress) {
      return 0;
    }

    if (item?.progress?.rules?.length && item?.progress?.rules?.length <= 2 && item?.progress?.rules[0]?.times_completed) {
      return item?.progress?.rules[0]?.times_completed;
    }

    if (item?.progress?.percent_completed) {
      return calculatePercentage(item?.progress?.percent_completed, getTotal(item));
    }

    return 0;
  }

  function getTotal(item: any) {
    if (item?.extra?.total) return item?.extra?.total;

    if (item?.progress?.rules?.length) return item?.progress?.rules?.length;

    return 1;
  }

  function parseDescription(description: string) {
    const parts = description.split(/<a href="([^"]*)">([^<]*)<\/a>/g);
    const elements = [];

    for (let i = 0; i < parts.length; i += 3) {
      elements.push(parts[i]);
      if (parts[i + 1]) {
        elements.push(
          <Link className="underline hover:text-white hover:font-bold" key={i} to={parts[i + 1]}>
            {parts[i + 2]}
          </Link>,
        );
      }
    }

    return elements;
  }

  return (
    <>
      <div className="mx-auto container p-3 lg:p-10 overflow-hidden">
        <div className="space-y-7 md:space-y-0 md:flex justify-between items-center mb-3 lg:mb-10">
          <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
            <div>
              <Link to="../">
                <button className="rounded-full bg-purple flex justify-center items-center p-1">
                  <RiArrowLeftSLine size={28} className="text-white" />
                </button>
              </Link>
            </div>

            <h1 className="text-lg lg:text-3xl  py-1 px-6 rounded-full">Lista de ações</h1>
          </div>
        </div>

        <Box className="mb-5">
          <Link className="hover:text-yellow" to="/loja">
            <div className="w-full space-y-5 ">
              <p className="text-yellow"> Participe e resgate um presente no Catálogo de Experiência</p>

              {/* <p>Realize todos os desafios e resgate um presente de lançamento</p> */}
            </div>
          </Link>
        </Box>

        <div>
          <h3 className="block text-[22px] mb-3 lg:mb-0" tabIndex={0}>
            <p>Realize todos as ações e resgate um presente de lançamento</p>
          </h3>

          <div className="mt2 mb-12">
            <p className="text-[19px]">
              Total de ações concluídas:{' '}
              <b className="text-yellow">
                {totalCompleted}/{total}
              </b>
            </p>
          </div>
        </div>

        {loadingList && (
          <div className="space-y-2">
            <ArticlePlaceholder />
            <ArticlePlaceholder />
          </div>
        )}

        {!loadingList && (
          <ul className="space-y-5">
            {list?.map((item: any) => (
              <li key={item._id} className="bg-maastricht-blue p-10 rounded-xl">
                <div className="flex items-center justify-between border-b border-[#072E4A] border-solid pb-5">
                  <p className="text-lg text-electric-blue">{item.challenge}</p>

                  <div className="flex items-center space-x-4 font-thin">
                    <b>{item.completed ? getTotal(item) : verifyRules(item)}</b>/{getTotal(item)}
                    <div
                      className={`${
                        item.completed ? 'bg-electric-blue' : 'bg-prussian-blue-2'
                      } rounded-full bg-electric-blue h-8 w-8 flex justify-center items-center`}
                    >
                      <BsCheck className={`${item.completed ? 'text-maastricht-blue-3' : 'text-[#4C6E86]'}`} size={30} />
                    </div>
                  </div>
                </div>
                {item.description && <div className="mt-5 font-thin">{parseDescription(item.description)}</div>}

                {/* <p className="mt-5 font-thin">{item.description}</p> */}
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
}
